import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EncryptionProvider } from '../../providers/encryption/encryption';
import { RequestServiceProvider } from '../../providers/request-service/request-service';
import { TransactionAlertProvider } from '../../providers/transaction-alert/transaction-alert';
import { LoadingProvider } from '../../providers/loading/loading';

/**
 * Generated class for the ChangePasswordPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-change-password',
  templateUrl: 'change-password.html',
})
export class ChangePasswordPage {

  changePassword:FormGroup;
  submitAttempt = false;
  passValidation = false;
  confirm_password = '';
  new_password = '';

  constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder, private encrypt :EncryptionProvider, private request : RequestServiceProvider, private alert: TransactionAlertProvider, private loading : LoadingProvider) {

    this.changePassword = this.formBuilder.group({
      old_pass: ['',Validators.required],
      new_pass:['',Validators.required],
      confirmPassword:['',Validators.required]  
  });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChangePasswordPage');
  }

  checkFocus(event){
    this.passValidation = false;
  }

  submit(){

    this.submitAttempt = true;
   
    if(this.changePassword.valid){
      if(this.changePassword.value.new_pass != this.changePassword.value.confirmPassword){
        this.passValidation = true;
      }
      if(this.changePassword.valid && !this.passValidation){

        this.loading.presentLoading('Processing...')

       let encryptedOldPass = this.encrypt.makeSha(this.changePassword.value.old_pass);

       // let data = {old_pass:encryptedOldPass,new_pass:this.changePassword.value.new_pass}

        this.request.postChangePassword(encryptedOldPass,this.changePassword.value.new_pass).subscribe(
          data => {
            this.loading.loader.dismiss().catch(()=>{})
            if(data.json().code === "0000"){
              this.alert.presentSuccessForChangePassword(data.json().desc);
            }else{
              this.alert.presentError(data.json().desc)
            }
          },
          error => {
            this.loading.loader.dismiss().catch(()=>{})
            this.alert.presentError(error.json().message);
            if(error.json().code == 403){
              this.request.logout();
            }
          }
        )
        
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/change-password/change-password.ts